import { Injectable } from '@angular/core';

@Injectable()
export class NetworkInformation {

    get connection() : [string, number] {
        var connectionType = 'Unknown';
        var downlinkMax : number = Infinity;

        if ('connection' in navigator) {
            connectionType = (navigator as any).connection.type;

            if ('downlinkMax' in (navigator as any).connection) {
                downlinkMax = (navigator as any).connection.downlinkMax;
            }
        }

        return [connectionType, downlinkMax];
    }
}